<template>
	<div class="final-protocol">
		<v-layout row>
			<v-spacer></v-spacer>
			<v-btn @click="print" class="mr-3 no-print">Wydrukuj</v-btn>
		</v-layout>
		<h2 class="d-none print-only ma-3">Protokół końcowy</h2>

		<h3 class="d-none print-only ma-3" v-if="contestData.name"> Konkurs: {{contestData.name}}</h3>
		<v-card>
			<v-card-title class="no-print">
				<h2>Protokół końcowy</h2>
			</v-card-title>
			<v-card-text>
				<v-textarea
					browser-autocomplete="off"
					label="Uwagi do protokołu końcowego"
					:auto-grow="true"
					v-model="finalProtocolText"
					aria-label="final protocol text"
					class="no-print"
					:readonly="!canEditFinalProtocol"
				/>
				<div v-if="finalProtocolText" class="div-for-print" style="white-space: pre-wrap"><p><strong style="font-size: 12px">Uwagi do protokołu końcowego</strong></p>{{finalProtocolText}}
				</div>
				<v-btn v-if="canEditFinalProtocol" @click="save">Zapisz</v-btn>

				<div class="mt-5" style="page-break-inside: avoid">
					<contest-documents-list
						:contest-id="contestData.id"
						:documents="contestDocuments"
						color="indigo"
						document-type="FINAL_PROTOCOL_DOCUMENT"
						header="Dokumenty protokołu końcowego"
						:read-only="!canEditFinalProtocol"/>
				</div>

			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	import {PublicContestDocument} from "@/api/generated/PublicContestDocument";
	import ContestDocumentsList from "./ContestDocumentsList";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {Files} from "@/utils/Files";

	export default {
		name: "FinalProtocolView",
		components: {ContestDocumentsList},
		data () {
			return {
				contestData: {
					id: this.$route.params.id,
					name: ''
				},
				contestDocuments: [],
				infoDocuments: [],
				finalProtocolText: "",
				canEditFinalProtocol: false
			};
		},

		created () {
			this.loadDocuments();
			this.loadContestName();
		},

		methods: {
			save () {
				PublicContest.postFinalProtocolText(this, this.contestData.id, {body: this.finalProtocolText});
			},

			loadContestName () {
				PublicContest.getContestName(this, this.contestData.id, successResponse => {
					this.contestData.name = successResponse.name;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować nazwy konkursu", errorResponse);
				});
			},

			loadDocuments () {
				PublicContestDocument.getFinalProtocol(this, this.contestData.id,
					successResponse => {
						this.addDocumentsToView(successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować dokumentów", errorResponse);
					});
			},

			addDocumentsToView (documents) {
				documents.forEach(document => {
          this.contestDocuments.push(document);
				});
			},

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getFinalProtocolPrintUrl(this.contestData.id),
					"protokół_końcowy.pdf");
			}
		},

		mounted () {
			PublicContest.getFinalProtocolCanEdit(this, this.contestData.id, (response) => this.canEditFinalProtocol = response);
			PublicContest.getFinalProtocolText(this, this.contestData.id, (response) => this.finalProtocolText = response.text);
		}
	};
</script>

<style scoped>

</style>